import React from "react";

// emphasis=true marks a section as visually primary (Team Reporting,
// Today's Work) — bigger heading, stronger border — so containers aren't
// all given equal weight. Leave it off for secondary/tertiary sections.
function SectionCard({ title, subtitle, action, children, className = "", bodyClassName = "", emphasis = false }) {
  return (
    <div className={`rounded-lg border bg-white ${emphasis ? "border-slate-200 shadow-sm" : "border-slate-200"} ${className}`}>
      {(title || subtitle || action) && (
        <div className={`flex items-center justify-between gap-3 border-b border-slate-100 px-3 ${emphasis ? "py-2.5" : "py-2"}`}>
          <div>
            {title && (
              <h3 className={`${emphasis ? "text-sm" : "text-sm"} font-semibold text-slate-800`}>{title}</h3>
            )}
            {subtitle && <p className="text-[10px] text-slate-400">{subtitle}</p>}
          </div>
          {action && <div className="shrink-0">{action}</div>}
        </div>
      )}
      <div className={bodyClassName}>{children}</div>
    </div>
  );
}

export default SectionCard;